module.exports = __webpack_public_path__ + "static/media/hall-CSS.bdc7a507.svg";